import type { ServerResponseV1 } from "@/http"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

interface AlbumPosition {
  albumId: number
  position: number
}

interface UseReorderAlbumsArgs {
  eventVaultId: number
  position: AlbumPosition
  page: number
  perPage: number
}

export async function reorderAlbums(eventVaultId: number, position: AlbumPosition, page: number, perPage: number) {
  return await v1.patch<ServerResponseV1<void>>(`/events/${eventVaultId}/albums/reorder?page=${page}&pageSize=${perPage}`, position)
}

export function useReorderAlbums() {
  return useMutation({
    mutationFn: ({ eventVaultId, position, page, perPage }: UseReorderAlbumsArgs) => reorderAlbums(eventVaultId, position, page, perPage),
  })
}
